import { FileText } from "lucide-react";
import DocumentCard from "./DocumentCard";

const DocumentsSection = ({
  t,
  styles,
  filteredDocuments,
  selectedDocuments,
  getFileIcon,
  formatDate,
  handleDocumentClick,
  theme,
  language,
}) => {
  return (
    <div id="documents-section" style={styles.card1}>
      <h3 style={styles.cardTitle}>
        <FileText size={28} />
        {t.documents} ({filteredDocuments.length})
      </h3>

      {filteredDocuments.length === 0 ? (
        <div style={styles.emptyState}>
          <FileText size={80} style={styles.emptyStateIcon} />
          <p style={styles.emptyStateText}>
            {language === "ar" ? "لا توجد مستندات" : "No documents found"}
          </p>
        </div>
      ) : (
        <div style={styles.documentGrid}>
          {filteredDocuments.map((doc) => (
            <DocumentCard
              key={doc.id}
              doc={doc}
              styles={styles}
              theme={theme}
              isSelected={selectedDocuments.includes(doc.id)}
              getFileIcon={getFileIcon}
              formatDate={formatDate}
              handleDocumentClick={handleDocumentClick}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default DocumentsSection;